import { Block } from "@block";
import { useDesktopMediaQuery } from "@media-query";
import { useNavigation } from "@react-navigation/core";
import { StackActions } from "@react-navigation/routers";
import { spacing } from "@styles/spacing";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { ParamCardPhysicalRegister } from "../reducer/types";
import { fetchCardPhysicalRegisterRequest } from "../reducer/actions";
import FormCardRegister from "./form-register/form-register";
import { getCardStoreSelector } from "../reducer/selectors";
import { pushAppFlyer } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import moment from "moment";

const CardPhysicalRegister = () => {
  const { t } = useTranslation();
  const dispatchStore = useDispatch();
  const { dispatch } = useNavigation();
  const isDesktop = useDesktopMediaQuery();

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const goManager = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_CARDS));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => goHome(),
    },
    {
      name: t("CARD_DICH_VU_THE"),
      onPressSubtitle: () => goManager(),
    },
    {
      name: t("CARD_PHAT_HANH_THE_VAT_LY"),
      onPressSubtitle: () => {},
    },
  ];

  const [cardInfo, setCardInfo] = React.useState<ParamCardPhysicalRegister>();

  const cardStore = useSelector(getCardStoreSelector);
  const contactId = useSelector(getContactIdSelector);

  const handlerParamsAppFlyer = () => {
    console.log("handlerParamsAppFlyer");
    const param = {
      full_name: cardInfo?.fullName,
      phone_number: cardInfo?.phoneNum,
      email: cardInfo?.email,
      address: cardInfo?.officeAddress,
      card_type: cardInfo?.cardType,
    };
    return {
      eventName: "af_apply_card",
      params: {
        af_apply_card_info: JSON.stringify(param),
        af_channel: "ib_rb",
      },
    };
  };

  const eventPushCleverTap = (status?: boolean, response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (status?: boolean, response?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_cardtype: cardInfo?.cardType || "",
      ct_fullname: cardInfo?.fullName || "",
      ct_phone: cardInfo?.phoneNum || "",
      ct_email: cardInfo?.email || "",
      ct_address: cardInfo?.officeAddress || "",
      ct_agree_t_c: moment(moment.now()).format("YYYY-MM-DD HH:mm:ss"),
      ct_error_message: status === false ? response || "" : "",
    };

    if (status !== undefined) {
      param = {
        ...param,
        ct_issuecard_registerform_status: status ? "success" : "failure",
      };
    }
    return {
      eventNameCT: "ct_issuecard_registerform",
      paramsCT: param,
    };
  };

  const requestRegister = (data: ParamCardPhysicalRegister) => {
    console.log("requestRegister: ", data);
    setCardInfo(data);
    dispatchStore(fetchCardPhysicalRegisterRequest(data));
  };

  React.useEffect(() => {
    if (cardStore.statusPhysicalRegister === "error") {
      eventPushCleverTap(false, cardStore.error);
    } else if (cardStore.statusPhysicalRegister === "ok") {
      eventPushCleverTap(true, undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardStore.statusPhysicalRegister]);

  React.useEffect(() => {
    if (cardStore.statusPhysicalRegister === "ok") {
      const { eventName, params } = handlerParamsAppFlyer();
      pushAppFlyer(eventName, params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardStore.statusPhysicalRegister]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("CARD_PHAT_HANH_THE_VAT_LY")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <FormCardRegister requestRegister={requestRegister} onCancel={() => goManager()} />
        </Block>
      </ScrollView>
    </Block>
  );
};

export default CardPhysicalRegister;
